// extracted by mini-css-extract-plugin
export default {"bodyButacas":"SeccionButacas_bodyButacas__j0xt-","header":"SeccionButacas_header__YQHYc"};